import { fromJS } from 'immutable';

import { FILE_FORMATS } from 'constants/reports';

import DropdownMenu, { CLASSES } from 'components/DropdownMenu';

import { Label } from 'styles/modals';

const FileFormatSelection = (props) => {
  const handleChangeFormat = (format) => () => {
    props.onSelectFormat(format);
  };

  const fileFormatOptions = fromJS(
    FILE_FORMATS.map((format) => ({
      id: format,
      renderedValue: format,
      handleClick: handleChangeFormat(format),
    }))
  );

  return (
    <div>
      <Label>{props.label}</Label>
      <DropdownMenu
        renderedValue={props.selectedFormat}
        items={fileFormatOptions}
        className={`${CLASSES.FULL_WIDTH}`}
        button
        showSelected
      />
    </div>
  );
};

export default FileFormatSelection;
